/**
 * 轻提示吐司(_shared C-6)。非阻塞、居中贴底,由调用方控制显隐/自动消失。
 */
export function Toast({ message }: { message: string }) {
  return (
    <div
      role="status"
      style={{
        position: 'fixed',
        left: '50%',
        bottom: 32,
        transform: 'translateX(-50%)',
        background: 'var(--color-foreground)',
        color: 'var(--color-background)',
        padding: '10px 16px',
        borderRadius: 'var(--radius-md)',
        boxShadow: 'var(--shadow-lg)',
        fontSize: 'var(--text-sm-size)',
        zIndex: 80,
        maxWidth: '80%',
        textAlign: 'center',
      }}
    >
      {message}
    </div>
  );
}
